import Vue from "vue";
import Router from "vue-router";
import { index, verify_token } from "@/api/userCenter/home";
import { getToken, setToken } from "@/utils/auth"; // 验权
import { Message } from "element-ui";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/* Router Modules */

// 登录注册相关路由
import loginRegist from "./modules/loginRegist";
// 公司页面路由
import company from "./modules/company";
// 支付页面路由
import pay from "./modules/pay";
// 辅料栏路由
import accessories from "./modules/accessories";
// 行业信息栏路由
import industryNews from "./modules/industryNews";
// 设计师栏路由
import designer from "./modules/designer";
// 图搜搜栏路由
import imgSearch from "./modules/imgSearch";
// 底部导航栏路由
import footNav from "./modules/footNav";
// 个人中心页面路由
import userCenter from "./modules/userCenter";
// 联盟页面路由
import union from "./modules/union";
// 定制版小程序路由
import independent from "./modules/independent";
// 核销管理路由
import writeoff from "./modules/writeoff";

export const constantRouterMap = [
  // 测试路由
  { path: "/ceshi", name: "ceshi", component: () => import("@/views/ceshi") },
  // 客户端富文本编辑器页面路由
  {
    path: "/client",
    name: "client",
    component: () => import("@/views/client")
  },
  // 拉链测试路由
  {
    path: "/testAdd",
    name: "testAdd",
    component: () => import("@/views/test/testAdd")
  },
  {
    path: "/testList",
    name: "testList",
    component: () => import("@/views/test/testList")
  },
  {
    path: "/testSearch",
    name: "testSearch",
    component: () => import("@/views/test/testSearch")
  },

  // 重定向页面
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index")
      }
    ]
  },
  { path: "*", redirect: "/404" },
  // 页面找不到404的路由
  { path: "/404", name: "404", component: () => import("@/views/404") },
  // 个人中心首页路由
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "loghome",
        name: "loghome",
        component: () => import("@/views/home/loghome")
      }
    ]
  },
  // 天露石企业简介--手机页面
  {
    path: "/tlsIntroduce",
    name: "tlsIntroduce",
    meta: { name: "天露石企业简介" },
    component: () => import("@/views/tlsIntroduce")
  },

  // 登录注册相关路由
  ...loginRegist,
  // 公司页面路由
  ...company,
  // 支付页面路由
  ...pay,
  // 辅料栏路由
  accessories,
  // 行业信息栏路由
  industryNews,
  // 设计师栏路由
  designer,
  // 图搜搜栏路由
  imgSearch,
  // 底部导航栏路由
  footNav,
  // 个人中心页面路由
  userCenter,
  // 联盟页面路由
  union,
  // 定制版小程序路由
  independent,
  // 核销管理路由
  writeoff
];

const router = new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});
router.beforeEach((to, from, next) => {

  if (to.query && to.query.token1) {
    console.log(to.query.token1);
    verify_token({ token: to.query.token1 }).then(res => {
      if (res.code == 200) {
        // console.log("存储设置token");
        setToken(res.userinfo);
        next();
      } else {
        Message({ message: res.msg, type: "error", duration: 3000 });
        setTimeout(() => {
          next({ path: "/login" });
        }, 2000);
      }
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js